var _defs, _g, _circle;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgColorModeLight = function SvgColorModeLight(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".light-a,.light-d{fill:none;}.light-a{stroke:#abaebe;stroke-miterlimit:10;}.light-circle{fill:#abaebe; opacity: 1}.light-c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1300 -38)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "light-a",
    transform: "translate(1306.5 44.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "light-c",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "light-d",
    cx: 5,
    cy: 5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    y2: 5,
    transform: "translate(1311.5 38)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    y2: 5,
    transform: "translate(1311.5 56)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    x1: 5,
    transform: "translate(1318 49.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    x1: 5,
    transform: "translate(1300 49.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    x1: 2,
    y2: 2,
    transform: "translate(1316.096 42.904)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    x1: 2,
    y2: 2,
    transform: "translate(1304.904 53.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    x1: 2,
    y1: 2,
    transform: "translate(1316.096 54.096)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "light-a",
    x1: 2,
    y1: 2,
    transform: "translate(1304.904 42.904)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "light-circle",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8.5 8.5)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorModeLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color-mode-light.d9901ce1.svg";
export { ForwardRef as ReactComponent };